let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("kBJjY")).then(() => parcelRequire('5TJ5b'));